// web-staking-estimator-frontend/src/services/map/configService.js

/**
 * Cached UI configuration
 */
const __uiCfgRef = { current: null };

/**
 * Load UI configuration from backend
 * Caches the result for subsequent calls
 * @returns {Promise<object>} UI configuration object
 */
export async function loadUiCfg() {
  if (__uiCfgRef.current) return __uiCfgRef.current;
  
  try {
    const response = await fetch("/api/config", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    
    if (response.ok) {
      const json = await response.json();
      __uiCfgRef.current = json?.config || {};
    } else {
      __uiCfgRef.current = {};
    }
  } catch {
    __uiCfgRef.current = {};
  }
  
  return __uiCfgRef.current;
}

/**
 * Get connector line symbol configuration from UI config
 * @param {object} cfg - UI configuration object
 * @returns {object} Symbol configuration for connector line
 */
export function connectorSymbolFromCfg(cfg) {
  const style = cfg?.map?.connector?.style === "solid" ? "solid" : "dash";
  const width = Number(cfg?.map?.connector?.width ?? 2);
  const color = Array.isArray(cfg?.map?.connector?.color)
    ? cfg.map.connector.color
    : [0, 120, 255, 1];
  
  return {
    type: "simple-line",
    style: style,
    width: width,
    color: color,
  };
}
